/**
 * @generated SignedSource<<d4dc2f91c60665fe027d57b6a9920fbb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type multiUserPicker_nativeIssueTable_MultiUserPickerCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "multiUserPicker_nativeIssueTable_MultiUserPickerCell";
};
export type multiUserPicker_nativeIssueTable_MultiUserPickerCell$key = {
  readonly " $data"?: multiUserPicker_nativeIssueTable_MultiUserPickerCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"multiUserPicker_nativeIssueTable_MultiUserPickerCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "multiUserPicker_nativeIssueTable_MultiUserPickerCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraMultipleSelectUserPickerField"
};

(node as any).hash = "6a94b62d1ee5b9d8e348b0b01dee08ff";

export default node;
